import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import globals from '../../lib/globals/globals';
import getJson from '../../lib/network/get-json';
import logger from '../../lib/logger/logger';

var getChatbotConfiguration = function getChatbotConfiguration() {
  return new Promise(function (resolve) {
    getJson({
      url: globals().wfBotAssistantUrl,
      includeRootContext: false
    }).then(function (result) {
      resolve(result);
    })["catch"](function (reason) {
      window.WF_CHATBOT.openModal && window.WF_CHATBOT.openModal();
      logger.error('Could not get Chatbot Configuration', reason);
    });
  });
};

export default getChatbotConfiguration;